import { gql } from "graphql-request";

export const Money = gql`
  fragment Money on Money {
    currencyCode
    value
    formatted
  }
`;
